<div class="card panel-flat-color secondary-panel small-panel" style="margin-top: 24px;">
    <div class="panel-flat-header small-header" style="margin-bottom: 0;">
        <div class="header-icon"><i class="fa fa-info-circle"></i></div>
        <h3>Invoice Details</h3>
        @if (!currentInvoice.isAdHoc) {
            <div class="float-end header-button-container">
                @if (editMode) {
                    <button type="button"
                            class="ace-btn btn-text has-icon btn-primary"
                            (click)="refreshCurrentInvoice()">
                        <i class="fa fa-refresh" title="Refresh" style="color: white;"></i>
                    </button>
                }
            </div>
        }
    </div>
    <div class="panel-flat-body">
        <table class="table table-borderless invoice-table">
            @if (!currentInvoice.isAdHoc) {
                <thead>
                    <tr>
                        <th>Parcel Acct Num</th>
                        <th>Appeal Level</th>
                        <th>Tax Year</th>
                        <th>Revision</th>
                        <th style="text-align: right;">Previous FMV</th>
                        @if (editMode) {
                            <th class="override-button">
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary btn-danger invisible">
                                    <i class="fa fa-undo"></i>
                                </button>
                            </th>
                        }
                        <th style="text-align: right;">Invoice FMV</th>
                        @if (editMode) {
                            <th class="override-button">
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary btn-danger invisible">
                                    <i class="fa fa-undo"></i>
                                </button>
                            </th>
                        }
                        <th style="text-align: right;">FMV Change</th>
                        <th style="text-align: right;">Tax Rate</th>
                        @if (editMode) {
                            <th class="override-button">
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary btn-danger invisible">
                                    <i class="fa fa-undo"></i>
                                </button>
                            </th>
                        }
                        <th style="text-align: right;">Savings</th>
                        @if (editMode) {
                            <th class="override-button">
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary btn-danger invisible">
                                    <i class="fa fa-undo"></i>
                                </button>
                            </th>
                        }
                        <th></th>
                    </tr>
                </thead>
            }
            <tbody>
                <!-- APPEALS -->
                @for (appeal of currentInvoice.appeals; track appeal; let i = $index) {
                    <tr class="delete-hover">
                        <td><a style="cursor:pointer;" (click)="navigateToParcel(appeal)">{{ appeal.parcelAcctNum }}</a>
                        </td>
                        <td>{{ appeal.appealLevelAbbr }}</td>
                        <td>{{ appeal.annualYear }}</td>
                        <td>{{ appeal.revisionDesc }}</td>
                        <td style="text-align: right;">{{ appeal.previousFMV | number: '1.0-0' }}</td>
                        @if (editMode) {
                            <td></td>
                        }
                        <td style="text-align: right;">{{ appeal.invoiceFMV | number: '1.0-0' }}</td>
                        @if (editMode) {
                            <td></td>
                        }
                        <td style="text-align: right;">
                            {{ appeal.previousFMV - appeal.invoiceFMV | number: '1.0-0' }}
                        </td>
                        <td style="text-align: right;">{{ appeal.taxRate | percent:'1.6-6' }}</td>
                        @if (editMode) {
                            <td></td>
                        }
                        <td style="text-align: right;">
                            <span [style.color]="appeal.savingsOverridden ? 'red' : 'black'">
                                ${{ appeal.savings | number:'1.2-2' }}
                            </span>
                        </td>
                        @if (editMode) {
                            <td></td>
                        }
                        <td>
                            @if (editMode) {
                                <span style="color: var(--ace-danger); float:right; cursor: pointer; width: 14px;"
                                      [style.display]="currentInvoice.appeals.length > 1 ? 'block' : 'none'">
                                    <i class="fa fa-remove"
                                       (click)="removeAppeal(i)"
                                       [class.hidden-hover]="currentInvoice.appeals.length > 1"></i>
                                </span>
                            }
                        </td>
                    </tr>
                }
                @if (!currentInvoice.isAdHoc) {
                    <tr style="height: 50px;">
                        <td colspan="4">
                            <div style="display: flex; justify-content: end;">
                                <div class="form-check">
                                    <input type="checkbox"
                                           id="include-other"
                                           class="form-check-input"
                                           [disabled]="!editMode"
                                           [(ngModel)]="currentInvoice.includeOtherParcels"
                                           (change)="includeOtherParcelChange()"/>
                                    <label style="width: inherit; height: inherit;"
                                           class="form-check-label"
                                           for="include-other">Other
                                        Site
                                        <span>{{ constants.PropertyTypeNames[currentInvoice.propertyTypeID] }}</span>
                                        Parcels</label>
                                </div>
                            </div>
                        </td>
                        <td style="vertical-align: middle;text-align: right">
                            @if (currentInvoice.includeOtherParcels) {
                                <span style="text-align: right;">{{ currentInvoice.otherParcelFMV | number: '1.0-0' }}</span>
                            }
                            @if (!currentInvoice.includeOtherParcels) {
                                <span style="text-align: right;">-</span>
                            }
                        </td>
                        @if (editMode) {
                            <td></td>
                        }
                        <td style="vertical-align: middle;text-align: right">
                            @if (currentInvoice.includeOtherParcels) {
                                <span style="text-align: right;">{{ currentInvoice.otherParcelFMV | number: '1.0-0' }}</span>
                            }
                            @if (!currentInvoice.includeOtherParcels) {
                                <span style="text-align: right;">-</span>
                            }
                        </td>
                        @if (editMode) {
                            <td></td>
                        }
                        <td colspan="3"></td>
                        @if (editMode) {
                            <td colspan="2"></td>
                        }
                        <td></td>
                    </tr>
                    <!--TOTALS-->
                    <tr class="single-column"
                        #invoiceDetailsTotals
                        invoiceDetailsTotals
                        [currentInvoice]="currentInvoice"
                        [editMode]="editMode"
                        (calculatedFieldChanged)="calculatedFieldChanged($event)">
                    </tr>
                }

                <tr class="single-column">
                    <td colspan="6">
                        <span style="font-weight: bold; margin-right: 10px;">Notes on Invoice:</span>
                        <input type="checkbox"
                               [disabled]="!editMode"
                               [(ngModel)]="currentInvoice.automaticallyUpdateNotes"
                               (change)="automatedNoteChange()"/>
                        <span>Automatically Update</span>
                    </td>
                    @if (editMode) {
                        <td colspan="3"></td>
                    }
                    <td colspan="2" style="text-align: right;">
                        @if (!currentInvoice.isAdHoc) {
                            <span>Contingency %: </span>
                        }
                        <!--The page jumps around a bit between edit and read mode. I think this could be fixed better by either
                        not using tables for layout or trying to space form inputs out differently, but as a quick-fix for
                        ad hoc invoices where it's particularly bad, just put an intentional 20em space for this two-column
                        part of the table-->
                        @if (currentInvoice.isAdHoc) {
                            <span
                                style="display:inline-block;width:20em;">
                            </span>
                        }
                    </td>
                    <td style="text-align: right;">
                        @if (editMode && !currentInvoice.isAdHoc) {
                            <input type="text" class="form-control"
                                   style="width: 100%; text-align: right;"
                                   [(ngModel)]="currentInvoice.displayContingencyPct"
                                   [style.color]="currentInvoice.contingencyPctStatus"
                                   currencyMask
                                   [options]="{ allowNegative: false, precision: 2, prefix: '', suffix: '%' }"
                                   (blur)="calculatedFieldChanged(CalculatedFields.ContingencyPct)"/>
                        }
                        @if (!editMode && !currentInvoice.isAdHoc) {
                            <span [style.color]="currentInvoice.contingencyPctStatus">
                                {{ currentInvoice.contingencyPct | percent: '1.2-2' }}
                            </span>
                        }
                    </td>
                    @if (editMode) {
                        <td class="override-button">
                            @if (editMode && currentInvoice.contingencyPctStatus === 'red') {
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary btn-danger"
                                        (click)="revertContingencyPct()">
                                    <i class="fa fa-undo"></i>
                                </button>
                            }
                        </td>
                    }
                    <td></td>
                </tr>
                <tr class="single-column">
                    <td colspan="5" rowspan="5">
                <textarea class="form-control"
                          style="width: 100%; height: 146px; min-width:20em;"
                          [disabled]="!editMode || currentInvoice.automaticallyUpdateNotes"
                          [style.color]="currentInvoice.automaticallyUpdateNotes ? 'black' : 'red'"
                          [(ngModel)]="currentInvoice.notes"></textarea>
                    </td>
                    <td rowspan="5"></td>
                    @if (editMode) {
                        <td colspan="3"></td>
                    }
                    <td colspan="2" style="text-align: right;">
                        @if (!currentInvoice.isAdHoc) {
                            <span>Contingency Cap:</span>
                        }
                    </td>
                    <td style="text-align: right;">
                        @if (editMode && !currentInvoice.isAdHoc) {
                            <input tyle="text"
                                   class="form-control"
                                   style="width: 100%; text-align: right;"
                                   [(ngModel)]="currentInvoice.contingencyCap"
                                   [style.color]="currentInvoice.contingencyCapStatus"
                                   (blur)="calculatedFieldChanged(CalculatedFields.ContingencyCap)"
                                   currencyMask
                                   [options]="{ allowNegative: false }"/>
                        }
                        @if (!editMode && !currentInvoice.isAdHoc) {
                            <span [style.color]="currentInvoice.contingencyCapStatus">
                                {{ currentInvoice.contingencyCap | currency:'USD' }}
                            </span>
                        }
                    </td>
                    @if (editMode) {
                        <td class="override-button">
                            @if (editMode && currentInvoice.contingencyCapStatus === 'red') {
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary btn-danger"
                                        (click)="revertContingencyCap()">
                                    <i class="fa fa-undo"></i>
                                </button>
                            }
                        </td>
                    }
                    <td></td>
                </tr>
                <tr class="single-column">
                    @if (editMode) {
                        <td colspan="3"></td>
                    }
                    <td colspan="2" style="text-align: right;">
                        @if (!currentInvoice.isAdHoc) {
                            <span>Contingency Fee Amount:</span>
                        }
                    </td>
                    <td style="text-align: right;">
                        @if (editMode && !currentInvoice.isAdHoc) {
                            <input type="text"
                                   class="form-control"
                                   [(ngModel)]="currentInvoice.feeAmount"
                                   style="width: 100%; text-align: right;"
                                   [style.color]="currentInvoice.feeAmountStatus"
                                   currencyMask
                                   [options]="{ allowNegative: false }"
                                   (blur)="calculatedFieldChanged(CalculatedFields.FeeAmount)"/>
                        }
                        @if (!editMode && !currentInvoice.isAdHoc) {
                            <span [style.color]="currentInvoice.feeAmountStatus">
                                {{ currentInvoice.feeAmount | currency:'USD' }}
                            </span>
                        }
                    </td>
                    @if (editMode) {
                        <td class="override-button">
                            @if (editMode && currentInvoice.feeAmountStatus === 'red') {
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary btn-danger"
                                        (click)="revertFeeAmount()">
                                    <i class="fa fa-undo"></i>
                                </button>
                            }
                        </td>
                    }
                    <td></td>
                </tr>
                <tr class="single-column">
                    @if (editMode) {
                        <td colspan="3"></td>
                    }
                    <td colspan="2" style="text-align: right;">
                        <span>Fixed Fee Amount:</span>
                    </td>
                    <td style="text-align: right;">
                        @if (editMode) {
                            <input type="text"
                                   class="form-control"
                                   [(ngModel)]="currentInvoice.fixedFee"
                                   style="width: 100%; text-align: right;"
                                   [style.color]="currentInvoice.fixedFeeStatus"
                                   currencyMask
                                   [options]="{ allowNegative: false }"
                                   (blur)="calculatedFieldChanged(CalculatedFields.FixedFee)"/>
                        }
                        @if (!editMode) {
                            <span [style.color]="currentInvoice.fixedFeeStatus">
                                {{ currentInvoice.fixedFee | currency:'USD' }}
                            </span>
                        }
                    </td>
                    @if (editMode) {
                        <td class="override-button">
                            @if (editMode && currentInvoice.fixedFeeStatus === 'red') {
                                <button type="button"
                                        class="ace-btn btn-sm btn-primary btn-danger"
                                        (click)="revertFixedFee()">
                                    <i class="fa fa-undo"></i>
                                </button>
                            }
                        </td>
                    }
                </tr>
                <tr class="single-column">
                    @if (editMode) {
                        <td colspan="3"></td>
                    }
                    <td colspan="2" style="text-align: right;">
                        <span>Expense Amount:</span>
                    </td>
                    <td style="text-align: right;">
                        @if (editMode) {
                            <input tyle="text"
                                   class="form-control"
                                   [(ngModel)]="currentInvoice.expenseAmount"
                                   style="width: 100%; text-align: right;"
                                   currencyMask
                                   [options]="{ allowNegative: false }"
                                   (blur)="calculatedFieldChanged(CalculatedFields.ExpenseAmount)"/>
                        }
                        @if (!editMode) {
                            <span>{{ currentInvoice.expenseAmount | currency:'USD' }}</span>
                        }
                    </td>
                    @if (editMode) {
                        <td class="override-button">
                            <!-- <button type="button"
                            class="ace-btn btn-sm btn-primary btn-danger"
                            *ngIf="editMode && currentInvoice.contingencyPctStatus == 'red'"
                            (click)="revertContingencyPct()">
                            <i class="fa fa-undo"></i>
                          </button> -->
                        </td>
                    }
                    <td></td>
                </tr>
                <tr class="single-column">
                    @if (editMode) {
                        <td colspan="3"></td>
                    }
                    <td colspan="2" style="text-align: right;">
                        <span>Invoice Amount:</span>
                    </td>
                    <td class="overline" style="text-align: right;">
                        <span [style.color]="currentInvoice.invoiceAmountStatus">
                            {{ currentInvoice.invoiceAmount | currency:'USD' }}
                        </span>
                    </td>
                    @if (editMode) {
                        <td class="override-button"></td>
                    }
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
